import { render, staticRenderFns } from "./BaseBackGroundCover.vue?vue&type=template&id=6ea8e23b&scoped=true&"
import script from "./BaseBackGroundCover.vue?vue&type=script&lang=js&"
export * from "./BaseBackGroundCover.vue?vue&type=script&lang=js&"
import style0 from "./BaseBackGroundCover.vue?vue&type=style&index=0&id=6ea8e23b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea8e23b",
  null
  
)

export default component.exports